(() => {
  const number = value => String(Number(value.toFixed(2)));
  const convert = (text, imperial) => text
    .replace(/\([^()]*\b(?:in|inches|oz)\b[^()]*\)/gi, '')
    .replace(/(\d+(?:\.\d+)?(?:\s*[×x–-]\s*\d+(?:\.\d+)?)*)\s*(mm|cm|g)\b/g, (_, values, unit) => {
      const factor = unit === 'g' ? (imperial ? 1 / 28.349523125 : 1) : unit === 'mm' ? (imperial ? 1 / 25.4 : 0.1) : (imperial ? 1 / 2.54 : 1);
      return values.replace(/\d+(?:\.\d+)?/g, n => number(Number(n) * factor)) + ' ' + (unit === 'g' ? (imperial ? 'oz' : 'g') : (imperial ? 'in' : 'cm'));
    }).replace(/\s+([.;])/g, '$1').replace(/\s{2,}/g, ' ').trim();
  const init = () => document.querySelectorAll('[data-ms-specs]:not([data-ready])').forEach(root => {
    root.dataset.ready = 'true';
    const rows = [];
    root.querySelectorAll('[data-ms-specs-source] p, [data-ms-specs-source] li').forEach(row => {
      const text = row.textContent.trim();
      const match = text.match(/^([^·:]{1,40})\s*[·:]\s*(.+)$/s);
      const measured = /\d\s*(?:mm|cm|g)\b/.test(text);
      if (match) {
        const label = document.createElement('strong');
        label.textContent = match[1].trim();
        const value = document.createElement('span');
        value.textContent = match[2];
        row.replaceChildren(label, value);
        row.classList.add('ms-spec-row');
        if (measured) rows.push({element:value, original:match[2]});
      } else if (measured) rows.push({element:row, original:text});
    });
    if (!rows.length) return;
    const controls = root.querySelector('.ms-specs-units');
    controls.hidden = false;
    const setUnit = unit => {
      rows.forEach(row => { row.element.textContent = convert(row.original, unit === 'imperial'); });
      controls.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.unit === unit)));
    };
    controls.addEventListener('click', event => {
      const button = event.target.closest('button[data-unit]');
      if (button) setUnit(button.dataset.unit);
    });
    setUnit('metric');
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
